// Restaurant order types (restoside app).

export type RestaurantOrderStatus = 'open' | 'submitted' | 'served' | 'cancelled'

export interface RestaurantOrderItem {
  _id: string
  id: string
  orderId: string
  sourceMenuItemId: string | null
  sourceDishId: string | null
  name: string
  unitPrice: number
  quantity: number
  lineTotal: number
}

export interface RestaurantOrder {
  _id: string
  id: string
  restaurantId: string
  status: RestaurantOrderStatus
  tableLabel: string | null
  note: string | null
  total: number
  itemCount: number
  createdBy: { _id: string; id: string; name: string }
  items: RestaurantOrderItem[]
  createdAt: string
  updatedAt: string
}

export const ORDER_STATUS_LABELS: Record<RestaurantOrderStatus, string> = {
  open: 'Open',
  submitted: 'Submitted',
  served: 'Served',
  cancelled: 'Cancelled',
}

export const ORDER_STATUS_BADGE: Record<RestaurantOrderStatus, string> = {
  open: 'bg-sky-500/20 text-sky-300 border border-sky-500/30',
  submitted: 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30',
  served: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
  cancelled: 'bg-red-500/20 text-red-300 border border-red-500/30',
}
